import { Radio } from 'antd'
import { useTranslation } from 'react-i18next'
import { CertificateType } from 'enum/certificateType.enum'
import { Wrapper, Option, Description, Title, Subtitle } from './styled'

interface IProps {
  value: CertificateType
  setValue: (value: CertificateType) => void
}

const Type = ({ value, setValue }: IProps) => {
  const { t } = useTranslation()
  const translatePrefix = 'administration.certificate.new'

  return (
    <Wrapper>
      <Option
        selected={value === CertificateType.individual}
        onClick={() => setValue(CertificateType.individual)}
      >
        <Radio checked={value === CertificateType.individual} />
        <Description>
          <Title>{t(`${translatePrefix}.types.individual`)}</Title>
          <Subtitle>{t(`${translatePrefix}.info.individual`)}</Subtitle>
        </Description>
      </Option>
      <Option
        selected={value === CertificateType.group}
        onClick={() => setValue(CertificateType.group)}
      >
        <Radio checked={value === CertificateType.group} />
        <Description>
          <Title>{t(`${translatePrefix}.types.grupal`)}</Title>
          <Subtitle>{t(`${translatePrefix}.info.grupal`)}</Subtitle>
        </Description>
      </Option>
    </Wrapper>
  )
}

export default Type
